


import { useState, useEffect } from "react";
import { ProSidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Box, IconButton, Typography, Tooltip, useTheme, useMediaQuery } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import EngineeringOutlinedIcon from "@mui/icons-material/EngineeringOutlined";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutlineOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";
import GavelOutlinedIcon from "@mui/icons-material/GavelOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";

import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import PieChartOutlineOutlinedIcon from "@mui/icons-material/PieChartOutlineOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import SubscriptionsOutlinedIcon from '@mui/icons-material/SubscriptionsOutlined';

import ListIcon from "@mui/icons-material/List";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined"; 
import FilterListIcon from "@mui/icons-material/FilterListOutlined"; 

import { useUser } from "../../common/UserContext";

import LogOffIcon from "@mui/icons-material/LogoutOutlined"; 

const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const Sidebar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [isCollapsed, setIsCollapsed] = useState(isMobile);
  const [selected, setSelected] = useState("Dashboard");

  const { appUserFirstName, appUserLastName, appUserRole } = useUser();

  const navigate = useNavigate();

/*  B E G I N    S H R I N K S    T H E    M E N U   H E I G H T  B A C K  100%  */
    useEffect(() => {
      
    // Function to update the height

      const timer = setTimeout(() => {
      //  alert(`Selected: ${selected}`);

        const totalHeight = 100;
      setBoxHeight(totalHeight + 'hv');

      }, 1000); // Delay the alert by 10 seconds
     
      return () => clearTimeout(timer); // Clean up the timer when the component unmounts or before the next effect runs

    }, [selected]); // This effect depends on 'selected' and runs when it changes

  /*  E N D    S H R I N K S    T H E    M E N U   H E I G H T  B A C K  100%  */

    
/*    B E G I N    C O D E    T O    M A K E    S U R E    S I D E    B A R    M A T C H   S C R O L L A B L E   A R E A    */  
const [boxHeight, setBoxHeight] = useState('auto');

useEffect(() => {
  // Function to update the height
  const updateHeight = () => {

    // Set the height to the total scrollable height of the document
    const totalHeight = document.documentElement.scrollHeight;
    setBoxHeight(totalHeight + 'px');
  };

   // Instantiate and configure MutationObserver
   const observer = new MutationObserver(mutations => {
    updateHeight();
  });

  // Start observing the body for DOM changes
  observer.observe(document.body, {
    childList: true,      // Observe direct children changes
    subtree: true,        // Observe all descendants
    attributes: true,     // Observe attributes changes
    characterData: true   // Observe text changes
  });

  // Update the height initially and on window resize
  updateHeight();
  window.addEventListener('resize', updateHeight);

  // Cleanup listener when component unmounts
  return () => {
    window.removeEventListener('resize', updateHeight);
    observer.disconnect();
  };
}, []);

/*    E N D     C O D E    T O    M A K E    S U R E    S I D E    B A R    M A T C H   S C R O L L A B L E   A R E A    */  

  return (

    <Box
    sx={{...(!isCollapsed ? { minWidth: '370px' } : {}),
      height: boxHeight, // Apply the dynamic height
      borderRight: "1px solid #5d5d5d",
      "& .pro-sidebar-inner": {
        background: `${colors.primary[600]} !important`,
      },
      "& .pro-icon-wrapper": {
        backgroundColor: "transparent !important",
      },
      "& .pro-inner-item": {
        padding: "5px 35px 5px 20px !important",
      },
      "& .pro-inner-item:hover": {
        color: "#868dfb !important",
      },
      "& .pro-menu-item.active": {
        color: "#6870fa !important",
      },
    }}
  >
    <ProSidebar collapsed={isCollapsed} style={isMobile ? {} : {...(!isCollapsed ? { width: '100%' } : {})}}>
      <Menu iconShape="square">
        {/* LOGO AND MENU ICON */}

        {!isMobile && 
        <MenuItem
          onClick={() => setIsCollapsed(!isCollapsed)}
          icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
          style={{
            margin: "10px 0 20px 0",
            color: colors.grey[100],
          }}
        >
          {!isCollapsed && (
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              ml="15px"
            >
              <Typography variant="h3" color={colors.grey[100]}> 
                 {/* ADMINIS */}
              </Typography>
              <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                <MenuOutlinedIcon />
              </IconButton>
            </Box>
          )}
        </MenuItem>
        }

        {!isCollapsed && (
          <Box mb="25px">
            <Box display="flex" justifyContent="center" alignItems="center">
              <img
                alt="profile-user"
                width="100px"
                height="100px"
                src={`../../assets/logo.png`}
                style={{ cursor: "pointer", borderRadius: "50%" }} 
                 onClick={() => window.location.href = "/"}
              />
            </Box>
            <Box textAlign="center">
              <Typography
                variant="h3"
                sx={{ m: "10px 0 0 0" }} style={{ cursor: "pointer", borderRadius: "50%" }} 
                 onClick={() => window.location.href = "/"}
              >
               Payexly
              </Typography>
              <Typography variant="h5" color={colors.greenAccent[500]} style={{ cursor: "pointer", borderRadius: "50%" }} 
                 onClick={() => window.location.href = "/"}>
                Organization Platform
              </Typography>
            </Box>
          </Box>
        )}

        <Box paddingLeft={isCollapsed ? undefined : "10%"}>
          <Item
            title="Dashboard"
            to="/app"
            icon={<HomeOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />

          <Tooltip title="These are the foundational records your account needs to function smoothly." arrow 
           PopperProps={{
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, 8],
                  },
                },
              ],
              sx: {
                '& .MuiTooltip-tooltip': {
                  fontSize: '16px',
                  padding: '8px 12px', // optional, for better readability
                },
              },
            }}
          >
            <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px" }}
            >
              Essentials
            </Typography>
          </Tooltip>

          
                <Item
                title="Organization"
                to="/organization"
                icon={<BusinessCenterOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
                />

            
                <Item
                title="Employees"
                to="/employees"
                icon={<BadgeOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
                />

            
                <Item
                title="Contractor Companies"
                to="/contractorcompanies"
                icon={<BusinessOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
                />

            
                <Item
                title="Contractors"
                to="/contractors"
                icon={<EngineeringOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
                />

            
                <Item
                title="Clients"
                to="/clients"
                icon={<PeopleOutlineOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
                />

            

          <Tooltip title="These are the day-to-day records you’ll create and manage as part of running your organization." arrow 
           PopperProps={{
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, 8],
                },
              },
            ],
            sx: {
              '& .MuiTooltip-tooltip': {
                fontSize: '16px',
                padding: '8px 12px', // optional, for better readability
              },
            },
          }}
          >
            <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px" }}
            >
              {isCollapsed ? 'Daily' : 'Daily Activities'}

            </Typography>
          </Tooltip>

          
                  <Item
                  title="Direct Deposits"
                  to="/directdeposits"
                  icon={<AccountBalanceOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                  />

                   
                  <Item
                  title="Tax Calculations"
                  to="/taxcalculations"
                  icon={<CalculateOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                  />

                   
  
              {!isMobile &&
                  <SubMenu
                    title="Garnishments"
                  to="/garnishments"
                    icon={<GavelOutlinedIcon />}
                    defaultOpen={false} // Control initial open state
                    style={{ color: colors.grey[100] }}
                    onClick={() => {
                    
                      if (!selected.includes("Garnishment"))
                      {
                        setSelected("Garnishment List");
                        navigate("/garnishments/list");
                      }
                    }}
                  >
                    <Item
                      title="Garnishment List"
                      to="/garnishments/list"
                      icon={<ListIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    
               
                    <Item
                      title="Garnishments by Status"
                      to="/garnishments/status"
                      icon={<CategoryOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

              

                    
                

                <Item
                title="Garnishments by Garnishment Type"
                to="/garnishments/garnishmenttype"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              

                  </SubMenu>
                }
  
                {isMobile && 
                  <Item
                  title="Garnishments"
                  to="/garnishments"
                  icon={<GavelOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                  />

                }
                   
  
              {!isMobile &&
                  <SubMenu
                    title="Payment Period"
                  to="/paymentperiod"
                    icon={<CalendarTodayOutlinedIcon />}
                    defaultOpen={false} // Control initial open state
                    style={{ color: colors.grey[100] }}
                    onClick={() => {
                    
                      if (!selected.includes("Payment Period"))
                      {
                        setSelected("Payment Period List");
                        navigate("/paymentperiod/list");
                      }
                    }}
                  >
                    <Item
                      title="Payment Period List"
                      to="/paymentperiod/list"
                      icon={<ListIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    

                    
                

                <Item
                title="Payment Period by Payroll Cycle"
                to="/paymentperiod/payrollcycle"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              

                  </SubMenu>
                }
  
                {isMobile && 
                  <Item
                  title="Payment Period"
                  to="/paymentperiod"
                  icon={<CalendarTodayOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                  />

                }
                   
  
              {!isMobile &&
                  <SubMenu
                    title="Employee Time Card"
                  to="/employeetimecard"
                    icon={<AccessTimeOutlinedIcon />}
                    defaultOpen={false} // Control initial open state
                    style={{ color: colors.grey[100] }}
                    onClick={() => {
                    
                      if (!selected.includes("Employee Time Card"))
                      {
                        setSelected("Employee Time Card List");
                        navigate("/employeetimecard/list");
                      }
                    }}
                  >
                    <Item
                      title="Employee Time Card List"
                      to="/employeetimecard/list"
                      icon={<ListIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    

                    
                

                <Item
                title="Employee Time Card by Shift Type"
                to="/employeetimecard/shifttype"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              

                  </SubMenu>
                }
  
                {isMobile && 
                  <Item
                  title="Employee Time Card"
                  to="/employeetimecard"
                  icon={<AccessTimeOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                  />

                }
                   
  
              {!isMobile &&
                  <SubMenu
                    title="Contractor Time Card"
                  to="/contractortimecard"
                    icon={<AccessTimeOutlinedIcon />}
                    defaultOpen={false} // Control initial open state
                    style={{ color: colors.grey[100] }}
                    onClick={() => {
                    
                      if (!selected.includes("Contractor Time Card"))
                      {
                        setSelected("Contractor Time Card List");
                        navigate("/contractortimecard/list");
                      }
                    }}
                  >
                    <Item
                      title="Contractor Time Card List"
                      to="/contractortimecard/list"
                      icon={<ListIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    

                    
                

                <Item
                title="Contractor Time Card by Shift Type"
                to="/contractortimecard/shifttype"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              

                  </SubMenu>
                }
  
                {isMobile && 
                  <Item
                  title="Contractor Time Card"
                  to="/contractortimecard"
                  icon={<AccessTimeOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                  />

                }
                   
  
              {!isMobile &&
                  <SubMenu
                    title="Employee Payroll"
                  to="/employeepayroll"
                    icon={<AttachMoneyOutlinedIcon />}
                    defaultOpen={false} // Control initial open state
                    style={{ color: colors.grey[100] }}
                    onClick={() => {
                    
                      if (!selected.includes("Employee Payroll"))
                      {
                        setSelected("Employee Payroll List");
                        navigate("/employeepayroll/list");
                      }
                    }}
                  >
                    <Item
                      title="Employee Payroll List"
                      to="/employeepayroll/list"
                      icon={<ListIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    

                    
                

                <Item
                title="Employee Payroll by Payment Method"
                to="/employeepayroll/paymentmethod"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              
                

                <Item
                title="Employee Payroll by Status"
                to="/employeepayroll/status"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              

                  </SubMenu>
                }
  
                {isMobile && 
                  <Item
                  title="Employee Payroll"
                  to="/employeepayroll"
                  icon={<AttachMoneyOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                  />

                }
                   
  
              {!isMobile &&
                  <SubMenu
                    title="Contractor Payroll"
                  to="/contractorpayroll"
                    icon={<AttachMoneyOutlinedIcon />}
                    defaultOpen={false} // Control initial open state
                    style={{ color: colors.grey[100] }}
                    onClick={() => {
                    
                      if (!selected.includes("Contractor Payroll"))
                      {
                        setSelected("Contractor Payroll List");
                        navigate("/contractorpayroll/list");
                      }
                    }}
                  >
                    <Item
                      title="Contractor Payroll List"
                      to="/contractorpayroll/list"
                      icon={<ListIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    

                    
                

                <Item
                title="Contractor Payroll by Payment Method"
                to="/contractorpayroll/paymentmethod"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              
                

                <Item
                title="Contractor Payroll by Status"
                to="/contractorpayroll/status"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              

                  </SubMenu>
                }
  
                {isMobile && 
                  <Item
                  title="Contractor Payroll"
                  to="/contractorpayroll"
                  icon={<AttachMoneyOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                  />

                }
                   
  
              {!isMobile &&
                  <SubMenu
                    title="Client Invoices"
                  to="/clientinvoices"
                    icon={<ReceiptLongOutlinedIcon />}
                    defaultOpen={false} // Control initial open state
                    style={{ color: colors.grey[100] }}
                    onClick={() => {
                    
                      if (!selected.includes("Client Invoice"))
                      {
                        setSelected("Client Invoice List");
                        navigate("/clientinvoices/list");
                      }
                    }}
                  >
                    <Item
                      title="Client Invoice List"
                      to="/clientinvoices/list"
                      icon={<ListIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    

                    
                

                <Item
                title="Client Invoices by Status"
                to="/clientinvoices/status"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              
                

                <Item
                title="Client Invoices by Payment Method"
                to="/clientinvoices/paymentmethod"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              

                  </SubMenu>
                }
  
                {isMobile && 
                  <Item
                  title="Client Invoices"
                  to="/clientinvoices"
                  icon={<ReceiptLongOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                  />

                }
                   
     
       {/*
           
          <Typography
            variant="h6"
            color={colors.grey[300]}
            sx={{ m: "15px 0 5px 20px" }}
          >

            Pages
          </Typography>
          <Item
            title="Calendar"
            to="/calendar"
            icon={<CalendarTodayOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />
     
          <Typography
            variant="h6"
            color={colors.grey[300]}
            sx={{ m: "15px 0 5px 20px" }}
          >
            Charts
          </Typography>
          <Item
            title="Bar Chart"
            to="/bar"
            icon={<BarChartOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Pie Chart"
            to="/pie"
            icon={<PieChartOutlineOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Line Chart"
            to="/line"
            icon={<TimelineOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Geography Chart"
            to="/geography"
            icon={<MapOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          */}

          <Typography
            variant="h6"
            color={colors.grey[300]}
            sx={{ m: "15px 0 5px 20px" }}
          >
            Account
          </Typography>

          {appUserRole === "admin" && (
          <Item
            title="Subscriptions"
            to="/subscriptions"
            icon={<SubscriptionsOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />
        )}

          {appUserRole === "admin" && (
            <Item
              title="User Accounts"
              to="/useraccounts"
              icon={<ManageAccountsOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
          )}

          <Item
            title="Log Out"
            to="/logout"
            icon={<LogOffIcon />}
            selected={selected}
            setSelected={setSelected}
          />

        </Box>
      </Menu>
    </ProSidebar>
  </Box>

  );
};

export default Sidebar;
